import "./App.css";
import React, { useState, useEffect } from "react";

import withAuthProvider from "./auth/AuthProvider";

import { BrowserRouter } from "react-router-dom";

import { UserContextProvider } from "./auth/userContext";
import ContentLayout from "./ContentLayout";
import ScrollButton from "./components/scrollButton";
function App(appProps) {
  return (
    <UserContextProvider>
      <BrowserRouter>
        <ContentLayout {...appProps} />
      </BrowserRouter>
    </UserContextProvider>
  );
}

export default withAuthProvider(App);
